<template>
	<v-col class="balance-mutation">
		<div class="d-flex justify-space-between">
			<div class="font-size-13 font-weight-bold secondary--text">Tambah Repeat Order</div>
		</div>
		<div class="mt-5">
			<v-row justify="space-between" class="align-center">
				<v-col cols="12" sm="6" md="4" lg="4" xl="3" class="">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow red darken-4"  v-if="Object.keys(quotaRO).length > 0">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="10" md="10">
								<div class="font-size-12 white--text font-weight-bold">{{ quotaRO.quota  | toRupiah }}</div>
								<div class="font-size-10 white--text">Total Kuota Anda</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<div class="pt-3 d-flex flex-wrap">
				<v-col cols="12" sm="6" md="6" lg="6" xl="5" class="px-0">
					<v-card class="pa-4 elevation-0 rounded-xl hover-shadow"  v-if="Object.keys(quotaRO).length > 0">
						<v-alert text outlined color="amber darken-2" class="pa-3 rounded-xl">
							<div class="font-size-11">Setiap Repeat Order akan mengurangi jumlah kuota Anda sebesar Rp 2.000.000</div>
						</v-alert>
						<div class="pt-3">
							<div class="pb-2 font-size-10 cl-grey">Silakan Input Jumlah Kuantiti Repeat Order</div>
							<div class="d-flex">
								<v-text-field outlined dense hide-details placeholder="Input Kuantiti" color="primary" class="rounded-xl" v-model="quantityRO" @keypress="onlyNumber" @paste.prevent @keyup="changeQuantityRO"></v-text-field>
								<v-btn height="40" depressed color="primary" class="ml-3 white--text rounded-xl text-capitalize" :loading="btnLoading" :disabled="!quantityRO" @click="showConfirm">
									<span>Proses</span>
								</v-btn>
							</div>
						</div>
					</v-card>
				</v-col>
			</div>
		</div>
		<ModalKonfirmasi ref="modalKonfirmasi" :msg="msgConfirm" @action="processRO"></ModalKonfirmasi>
		<ModalSukses ref="modalSukses" :msg="msgSuccess"></ModalSukses>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalKonfirmasi from '@/components/modals/vo-general/ModalKonfirmasi'
import ModalSukses from '@/components/modals/vo-general/ModalSukses'

export default {
	components: {
		ModalKonfirmasi, ModalSukses
	},
	data() {
		return {
			loading: false,
			btnLoading: false,
			quantityRO: '',
			msgConfirm: '',
			msgSuccess: 'Anda Berhasil Melakukan Repeat Order',
		}
	},
	computed: {
		...mapState('repeatOrder', ['quotaRO']),
	},
	methods: {
		...mapActions('repeatOrder', ['getQuotaRO', 'addRO']),

		getData() {
			this.loading = true
			this.getQuotaRO().then(() => {
        document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		showConfirm() {
			this.msgConfirm = `
			<div>Apakah Anda yakin untuk melakukan Repeat Order?</div>
			<div><b>${this.$options.filters.toRupiah(this.quantityRO * 2000000)}</b> akan dipotong dari Kuota Anda</div>
			`
			this.$refs.modalKonfirmasi.modalShow()
		},
		changeQuantityRO() {
			if (this.quantityRO > 1000) {
				this.quantityRO = 1000
			}
		},
		processRO() {
			this.$refs.modalKonfirmasi.loadingButton()
			this.addRO({ quota_qty: this.quantityRO }).then(() => {
				this.$refs.modalKonfirmasi.modalHide()
				this.quantityRO = ''
				this.getData()
				this.$refs.modalSukses.modalShow()
			}).catch(() => {
				this.$refs.modalKonfirmasi.modalHide()
			})
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Tambah Repeat Order`)
		this.getData()
	}
};
</script>